import { TenantUserUsecaseInterface, UpdateStatusParams } from "./usecase.d";
import { TenantUserRepository } from "../../services/TenantUser/tenantUser.repository";
import * as TenantUserReducer from "./reducer";
import { ActionType } from "./types";
import {
  DeleteParams,
  GetListParams,
} from "../../services/TenantUser/tenantUser.repository.d";
import { CreateTenantUserDto } from "../../services/TenantUser/dto/create.dto";
import { UpdateTenantUserDto } from "../../services/TenantUser/dto/update.dto";

export class TenantUserUsecase implements TenantUserUsecaseInterface {
  dispatch?: TenantUserReducer.TenantUserDispatch;
  repository: TenantUserRepository;

  constructor(dispatch?: TenantUserReducer.TenantUserDispatch) {
    this.repository = new TenantUserRepository();
    this.dispatch = dispatch;
  }

  async getList(params: GetListParams) {
    if (!params.role) {
      params.role = ["Super Moderator", "Moderator", "Sale"];
    }
    const response = await this.repository.getList(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.GetList,
        items: response,
      });
    }
  }

  async create(params: CreateTenantUserDto) {
    const response = await this.repository.create(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.Create,
        addedItem: response.data,
      });
    }
  }

  async update(params: UpdateTenantUserDto) {
    const response = await this.repository.update(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.Update,
        updatedItem: response.data,
      });
    }
  }

  async updateStatus(params: UpdateStatusParams) {
    if (this.dispatch) {
      this.dispatch({
        type: ActionType.UpdateStatus,
        updatedStatusItem: params,
      });
    }

    try {
      await this.repository.update({
        id: params.id,
        isActive: params.isActive,
      });
    } catch (error) {
      if (this.dispatch) {
        this.dispatch({
          type: ActionType.UpdateStatus,
          updatedStatusItem: {
            id: params.id,
            isActive: !params.isActive,
          },
        });
      }
      throw error;
    }
  }

  async delete({ id }: DeleteParams) {
    await this.repository.delete({ id });

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.Delete,
        deletedId: id,
      });
    }
  }
}
